module.exports = __webpack_public_path__ + "static/img/bg.fa333a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/appInfo/vanish/bg.jpg
// module id = 694
// module chunks = 1